module.exports = __webpack_public_path__ + "static/Review-img-1-bc583f40c184663c43ff4a6baf151cad.png";